export const DEFAULT_AUTH_URL = `http://localhost:8083`

export const MOCK_USER_ID = `367764c4-ca45-4d74-a274-ee1f262ac5b2`
